/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ContinueInputs */

const en_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const de_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const fr_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const es_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const it_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua`)
};

const nl_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doorgaan`)
};

const pl_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontynuuj`)
};

const fi_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jatka`)
};

const da_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortsæt`)
};

const sv_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortsätt`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Common_ContinueInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_continue = /** @type {((inputs?: Common_ContinueInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ContinueInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_continue(inputs)
	if (locale === "fr") return fr_common_continue(inputs)
	if (locale === "es") return es_common_continue(inputs)
	if (locale === "it") return it_common_continue(inputs)
	if (locale === "nl") return nl_common_continue(inputs)
	if (locale === "pl") return pl_common_continue(inputs)
	if (locale === "fi") return fi_common_continue(inputs)
	if (locale === "da") return da_common_continue(inputs)
	if (locale === "sv") return sv_common_continue(inputs)
	return en_common_continue(inputs)
});